import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Loader2 } from "lucide-react";

export default function HautVoixSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Laisse le temps au webhook / à la fonction d'enregistrer le paiement
    const t = setTimeout(() => setIsLoading(false), 1500);
    return () => clearTimeout(t);
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-[#FFF200] flex items-center justify-center px-4 py-10">
      <div className="max-w-lg w-full">
        <h1 className="text-3xl font-extrabold italic uppercase text-[#0A1A6B] text-center mb-6">
          À Haute Voix
        </h1>
        <Card className="border-0 shadow-2xl">
          <CardContent className="pt-8 pb-8 text-center">
            {isLoading ? (
              <>
                <Loader2 className="h-10 w-10 animate-spin text-[#0A1A6B] mx-auto mb-3" />
                <p className="text-muted-foreground">Validation de votre paiement...</p>
              </>
            ) : (
              <>
                <CheckCircle className="h-14 w-14 text-green-600 mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-[#0A1A6B] mb-3">
                  Merci, votre paiement est bien enregistré
                </h2>
                <p className="text-muted-foreground whitespace-pre-line">
                  Votre inscription est en cours de validation par le bureau de l'association.
                </p>
                <Button
                  className="mt-6 bg-[#0A1A6B] hover:bg-[#06124d] text-white"
                  onClick={() => navigate("/inscription-AHV2026")}
                >
                  Retour
                </Button>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
